/*
 * Copyright (c) 2024 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name: GreenlightTextData.js
 *
 * Description:	Functionality for loading and getting text data for greenlight documents.
 * 
 */

// The text data object.
var g_oTextData = {};

(function () {
	"use strict";

	/**
	 * Load the text data for greenlight documents.
	 */
	function TextData() {

		// The list of loaded text data for greenlight documents.
		this.g_oLoadedTextData = [];
	};

	/**
	 * Gets the text data for a document page.
	 * @param {int} DocumentId - The id of the document.
	 * @param {int} PageNumber - The page number.
	 * @returns {object} - The text data.
	 */
	TextData.prototype.getTextData = function (DocumentId, PageNumber) {

		// Outline the text data to be returned.
		var oTextData = null;

		// Loop through each of the text data we have.
		for (var i = 0; i < g_oTextData.g_oLoadedTextData.length; i++) {

			// If this is the text data for the document page.
			if (g_oTextData.g_oLoadedTextData[i].documentId == DocumentId && g_oTextData.g_oLoadedTextData[i].pageNumber == PageNumber) {

				// Return the text data.
				oTextData = g_oTextData.g_oLoadedTextData[i];
				break;
			}
		}

		// Return the text data.
		return oTextData;
	};

	/**
	 * Removes text data for a document page.
	 * @param {int} DocumentId - The id of the document.
	 * @param {int} PageNumber - The page number.
	 */
	TextData.prototype.removeTextData = function (DocumentId, PageNumber) {

		// Loop through each of the text data we have.
		for (var i = 0; i < g_oTextData.g_oLoadedTextData.length; i++) {

			// If this is the text data for the document page.
			if (g_oTextData.g_oLoadedTextData[i].documentId == DocumentId && g_oTextData.g_oLoadedTextData[i].pageNumber == PageNumber) {

				// Remove the text data.
				g_oTextData.g_oLoadedTextData.splice(i, 1);
				break;
			}
		}
	};

	/**
	 * Loads the text data for a document page.
	 * @param {int} DocumentId - The id of the document.
	 * @param {int} PageNumber - The page number.
	 * @param {bool} ShowEmptyTextDataError - If an error should be shown for empty text data.
	 * @param {function} Callback - The callback once loaded.
	 */
	TextData.prototype.loadTextData = function (DocumentId, PageNumber, ShowEmptyTextDataError, Callback) {
		
		// Get the text data for this document page.
		var oTextData = g_oTextData.getTextData(DocumentId, PageNumber);

		// If this text data has already been loaded.
		if (oTextData != null && oTextData.textData != null) {

			// Call the callback.
			Callback();
			return;
		}
		// If this text data is in the process of loading.
		else if (oTextData != null && oTextData.textData == null) {

			// Add the callback to be called when the text data is loaded.
			oTextData.callbacks.push(Callback);
			return;
		}

		// Add the text data for this document page with the callback.
		g_oTextData.g_oLoadedTextData.push({
			documentId: DocumentId,
			pageNumber: PageNumber,
			textData: null,
			callbacks: [Callback]
		});

		// Build up the JSON to be posted.
		var oJSON = {
			SessionId: g_szSessionId,
			DocumentId: DocumentId,
			PageNumber: PageNumber
		};
		
		// Call to load the text data.
		$.ajax({
			type: "POST",
			url: "TextTools/GetTextData",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oTextData.loadTextData_CH(DocumentId, PageNumber, ShowEmptyTextDataError, response);
			},
			failure: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oTextData.c_szFailedToLoadTextData);
			},
			error: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oTextData.c_szFailedToLoadTextData);
			},
		});
	};

	/**
	 * Callback for loading the text data for a document page.
	 * @param {int} DocumentId - The id of the document.
	 * @param {int} PageNumber - The page number.
	 * @param {bool} ShowEmptyTextDataError - If an error should be shown for empty text data.
	 * @param {object} Response - The response from loading.
	 */
	TextData.prototype.loadTextData_CH = function (DocumentId, PageNumber, ShowEmptyTextDataError, Response) {

		// If unsuccessful.
		if (!Response.Success) {
			g_oTextData.removeTextData(DocumentId, PageNumber);
			g_oGreenlightMessages.displayErrorBubble(g_oTextData.c_szDocumentHasNoLiveText);
			return;
		}

		// Extract the text content.
		var oTextContent = JSON.parse(Response.Contents);

		// Check for empty text data if required.
		if (ShowEmptyTextDataError && oTextContent.Paragraphs.length == 0) {
			g_oTextData.removeTextData(DocumentId, PageNumber);
			g_oGreenlightMessages.displayErrorBubble(g_oTextData.c_szDocumentHasNoLiveText);
			return;
		}

		// Get the text data for this document page.
		var oTextData = g_oTextData.getTextData(DocumentId, PageNumber);

		// Add the text data content.
		oTextData.textData = oTextContent;

		// Call each of the callbacks for the text data.
		for (var i = 0; i < oTextData.callbacks.length; i++) {
			oTextData.callbacks[i]();
			oTextData.callbacks.splice(i, 1);
			i--;
		}
	};

	/**
	 * Loads the text data for all the pages in a document.
	 * @param {object} oDocument - The document.
	 * @param {object} Callback - The callback.
	 */
	TextData.prototype.loadFullTextData = function (oDocument, Callback) {
		
		// If this text data has already been loaded.
		if (g_oTextData.fullDocumentDataLoaded(oDocument)) {

			// Call the callback.
			Callback();
			return
		}

		// Load the text data for each of the document pages.
		for (var i = 0; i < oDocument.pages.length; i++) {

			// Load the text data for the document page.
			g_oTextData.loadTextData(oDocument.documentId, oDocument.pages[i].documentPageNumber, false, function () { g_oTextData.loadFullTextData_CH(oDocument, Callback); });
		}
	};

	/**
	 * Callback for loading all the text data for a document.
	 * @param {any} oDocument - The document.
	 * @param {any} Callback - The callback.
	 */
	TextData.prototype.loadFullTextData_CH = function (oDocument, Callback) {
		
		// Check to ensure we have loaded the text data for all pages on this document.
		if (!g_oTextData.fullDocumentDataLoaded(oDocument)) {
			return;
		}

		// Check to see if we need an error when no pages have text data.
		if (!g_oTextData.fullDocumentHasLiveText(oDocument)) {
			g_oGreenlightMessages.displayErrorBubble(g_oTextData.c_szDocumentHasNoLiveText);
		}

		// Call the callback once all pages have loaded.
		Callback();
	};

	/**
	 * Checks if the full data has been loaded for a document.
	 * @param {object} oDocument - The document.
	 * @returns - If the full data has been loaded.
	 */
	TextData.prototype.fullDocumentDataLoaded = function (oDocument) {

		// Check to ensure we have loaded the text data for all pages on this document.
		for (var i = 0; i < oDocument.pages.length; i++) {
			var oTextData = g_oTextData.getTextData(oDocument.documentId, oDocument.pages[i].documentPageNumber);
			if (oTextData == null || oTextData.textData == null) {

				// Document page not loaded.
				return false;
			}
		}

		// All document pages loaded.
		return true;
	}

	/**
	 * Checks if the full document has live text.
	 * @param {object} oDocument - The document.
	 * @returns - If the full document has live text.
	 */
	TextData.prototype.fullDocumentHasLiveText = function (oDocument) {

		// Check for any text content.
		for (var i = 0; i < oDocument.pages.length; i++) {
			var oTextData = g_oTextData.getTextData(oDocument.documentId, oDocument.pages[i].documentPageNumber);
			if (oTextData != null && oTextData.textData != null && oTextData.textData.Paragraphs.length > 0) {

				// Document page has text data.
				return true;
			}
		}

		// All document pages have no text data.
		return false;
	}

	// Add the Text Data UI object to the window.
	window.TextData = TextData;
}());